var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.965 7.612a3.214 3.214 0 012.256 2.282c.533 2.013.533 6.213.533 6.213s0 4.2-.534 6.213a3.214 3.214 0 01-2.255 2.282c-1.989.54-9.965.54-9.965.54s-7.976 0-9.966-.54A3.214 3.214 0 013.78 22.32c-.533-2.013-.533-6.213-.533-6.213s0-4.2.533-6.213a3.214 3.214 0 012.255-2.282c1.99-.54 9.966-.54 9.966-.54s7.976 0 9.965.54zm-12.574 4.682v7.626l6.667-3.813-6.667-3.813z",
    fill: "#fff"
  })));
}

export default SvgYoutube;